export default __webpack_public_path__ + "static/media/sec_3_promo.85b1f784.svg";